var _style, _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWritingPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes sqt {\n      0% { transform: translate(0); }\n      100% { transform: translate(8px, 0); }\n    }\n    #squiggle { animation: sqt .4s linear infinite; }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.3255C3 17.8363 3 17.5917 3.05526 17.3615C3.10425 17.1574 3.18506 16.9624 3.29472 16.7834C3.4184 16.5816 3.59136 16.4086 3.93726 16.0627L16.5 3.49998C17.3285 2.67156 18.6716 2.67156 19.5 3.49998C20.3285 4.32841 20.3285 5.67156 19.5 6.49998L6.93729 19.0627C6.59138 19.4086 6.41843 19.5816 6.2166 19.7053C6.03765 19.8149 5.84256 19.8957 5.63849 19.9447C5.40832 20 5.16372 20 4.67454 20H3V18.3255Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_writing",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 16,
    width: 11,
    height: 6
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 16,
    width: 10,
    height: 6,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_writing)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "squiggle",
    d: "M29.5 18L28.4999 19.094C27.9695 19.6741 27.2502 20 26.5002 20C25.7501 20 25.0308 19.6741 24.5004 19.094C23.9692 18.5151 23.25 18.1901 22.5002 18.1901C21.7504 18.1901 21.0312 18.5151 20.5 19.094C19.9696 19.6741 19.2502 19.9999 18.5002 19.9999C17.7501 19.9999 17.0308 19.674 16.5004 19.0939C15.9692 18.515 15.25 18.1899 14.5002 18.1899C13.7504 18.1899 13.0312 18.515 12.5 19.0939C11.9696 19.674 11.2502 19.9999 10.5002 19.9999C9.75013 19.9999 9.03082 19.674 8.50041 19.0939C7.96925 18.515 7.25 18.1899 6.5002 18.1899C5.7504 18.1899 5.03116 18.515 4.5 19.0939",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingPencil);
export default __webpack_public_path__ + "static/media/writing-pencil.35c0243ee3bf0d32242d0cb91b1f19b0.svg";
export { ForwardRef as ReactComponent };